export const config = {
  id: 'product-owner',
  icon: 'Users',
  color: 'cyan',
  title: 'Product Owner',
  description: 'Agile product ownership, backlog management, and stakeholder collaboration',
  department: 'Product',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux'],
  estimatedOnboardingDays: {
    junior: 4,
    mid: 3,
    senior: 2
  }
};
